// extracted by mini-css-extract-plugin
export default {"readEnd":"index_readEnd_iUQ9H","readEndText":"index_readEndText_5utxM","readEndLeftLine":"index_readEndLeftLine_fWK6t","readEndRightLine":"index_readEndRightLine_f8w6p"};